export default {
  empty_list: 'Nog geen categorieën',
  uses_restaurant_open_times: 'Gebruikt openingstijden restaurant',
  products_creation_disabled:
    'Vanwege de actieve integratie met {{integration}} is het aanmaken van nieuwe producten niet toegestaan. Als u het menu wilt wijzigen, breng de wijzigingen dan aan in {{integration}} en synchroniseer het menu.',
  buttons: {
    add_category: 'Categorie toevoegen',
  },
  toasts: {
    something_went_wrong: 'Er is iets misgegaan',
  },
};
